// extracted by mini-css-extract-plugin
module.exports = {"paginator":"styles-module--paginator--3N9CM","link":"styles-module--link--1APIq","linkNext":"styles-module--linkNext--1TU3i","linkPrevious":"styles-module--linkPrevious--yM5Et"};